import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, matchPath } from 'react-router-dom';
import { isSmallerSelector } from '../layout/mediaquery';
import { ROUTE_CAMPAIGN_REGISTER } from '../router/constants.js';
import useCasinoRoutes from '../router/use-casino-routes';

const useLocationHasFooter = () => {
	const isSmaller = useSelector(isSmallerSelector);
	const location = useLocation();

	const { ROUTE_CASINO_SEARCH, ROUTE_LIVE_CASINO_SEARCH, ROUTE_LIVE_CASINO_GAME, ROUTE_CASINO_GAME } =
		useCasinoRoutes();

	const isInvalidRoute = useMemo(() => {
		const SMALLER_INVALID_ROUTES = [
			ROUTE_CASINO_GAME,
			ROUTE_CASINO_SEARCH,
			ROUTE_LIVE_CASINO_GAME,
			ROUTE_LIVE_CASINO_SEARCH
		];
		const INVALID_ROUTES = [ROUTE_CAMPAIGN_REGISTER];

		return isSmaller
			? SMALLER_INVALID_ROUTES.some(route => matchPath(route, location.pathname))
			: INVALID_ROUTES.some(route => matchPath(route, location.pathname));
	}, [
		ROUTE_CASINO_GAME,
		ROUTE_CASINO_SEARCH,
		ROUTE_LIVE_CASINO_GAME,
		ROUTE_LIVE_CASINO_SEARCH,
		isSmaller,
		location.pathname
	]);
	// has footer if its a valid route
	return !isInvalidRoute;
};

export default useLocationHasFooter;
